module.exports = __webpack_public_path__ + "static/media/refresh_selected.57044df6.svg";